import BannerProjects from '../../components/bannerProjects'
import DevopsAgility from '../../components/devopsAgility'
import DevopsBeneficios from '../../components/devopsBeneficios'
import DevopsOtimize from '../../components/devopsOtimize'
import Rodape from '../../components/rodape'

function Devops() {
  return (
    <>
      <BannerProjects
        backgroundImage="../assets/cover-devops.png"
        bgMobile="../assets/cover-devops-mobile.png"
        title="/DEVOPS"
        titleBold=""
        iconSrc="../assets/icone-projectiva-nex2ai.png"
        iconAlt="Projectiva Nex2AI"
        iconText="nex"
        iconTextBold="2ai"
        descriptionBold=""
        description={
          <>
            <span className="font-titillium-web-bold">Otimização</span> das
            etapas do ciclo de vida de desenvolvimento de software para{' '}
            <span className="font-titillium-web-bold">acelerar</span> o tempo de
            lançamento de seus produtos. Implemente práticas de DevOps, CI/CD,
            IaC e Monitoramento do Desempenho de sua Infraestrutura e Aplicações
            e{' '}
            <span className="font-titillium-web-bold">
              agilize sua jornada.
            </span>
          </>
        }
        footerText="VERTICAL INNOVATION | Cloud"
        buttonText="Quero me conectar"
        buttonColor="from-[#FC0021] via-[#FC0021] to-[#5534D9]"
        brand="nex2ai"
      />
      <DevopsAgility />
      <DevopsOtimize />
      <DevopsBeneficios />
      <Rodape />
    </>
  )
}

export default Devops
